import { differenceInCalendarDays, parseISO } from "date-fns";

/**
 * Spare capacity a guard could self-claim. Publishing a shift with none of these
 * is a no-op: the guard-facing list filters on reserved < numberOfGuards, so a
 * fully-staffed shift is never shown to anyone no matter what the flag says.
 */
export function openSpotCount(numberOfGuards: number, assignedGuardCount: number): number {
  return Math.max(0, numberOfGuards - assignedGuardCount);
}

/** Null when the shift ends on its start date, so the caller renders nothing. */
export function endDateOffsetLabel(startDate: string, endDate: string): string | null {
  if (!startDate || !endDate) return null;
  try {
    const days = differenceInCalendarDays(parseISO(endDate), parseISO(startDate));
    if (days <= 0) return null;
    return days === 1 ? "Overnight — ends next day" : `Ends ${days} days later`;
  } catch {
    return null;
  }
}
